import { render, staticRenderFns } from "./QuickAccessCards.vue?vue&type=template&id=329d5759&scoped=true&"
import script from "./QuickAccessCards.vue?vue&type=script&lang=js&"
export * from "./QuickAccessCards.vue?vue&type=script&lang=js&"
import style0 from "./QuickAccessCards.vue?vue&type=style&index=0&id=329d5759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d5759",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
